import {makeStyles} from '@material-ui/core/styles';
import {Colors} from '../../styles/Colors';
import mainBg from '../../assets/main_bg.png';

export const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: Colors.SignInRootBackground,
        backgroundBlendMode: 'multiply',
        backgroundImage: `linear-gradient(269.9deg, rgba(255,255,255,0.1) 0.01%, rgba(255,255,255,0.2) 99.83%), url(${mainBg})`,
        backgroundSize: 'cover',
        position: 'fixed' as const,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
    },

    wrapper: {
        height: 515,
        width: 515,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: Colors.White,
        border: '1px solid #000000',
        borderColor: Colors.Border,
        borderRadius: 16,
        boxShadow: '0 9px 46px 0 rgba(0, 0, 0, 0.10)',
        alignItems: 'center',

        '& .MuiGrid-root.MuiGrid-item ': {
            marginBottom: 20,
        },
    },

    credentials: {
        width: 372,
        display: 'flex',
        flexDirection: 'column',

        '& form': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            flexGrow: 1,
        },
    },
}));
